<template>
  <page-view title="京东联盟账户">
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="LianMengPeiZhi"></demo-video-alert>
    </div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="京东联盟ID">
                <a-input v-model="queryParam.keywords" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <template v-if="advanced"></template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button type="primary" @click="$refs.addModal.show()">新增联盟账户</a-button>
      </div>
      <s-table ref="table" size="default" rowKey="union_id" :columns="columns" :data="loadData" :scroll="{ x: 1200 }">
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <div slot="remarks_text" slot-scope="text, record">{{ record.remark ? record.remark : '无' }}</div>
        <span slot="robot_num" slot-scope="text">
          <a>{{ text }}</a>
        </span>
        <span slot="auth_status" slot-scope="text">
          <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
        </span>
        <span slot="is_sync" slot-scope="text, record">
          <a-switch checked-children="开" un-checked-children="关" :default-checked="text == 2"
            @change="(e) => handleSysChange(e, record.union_id)" />
        </span>
        <span slot="time" slot-scope="text">{{ text }}</span>
        <span slot="action" slot-scope="record">
          <a @click="positionSync(record)">设置自定义推广位同步</a>
          <a-divider type="vertical" />
          <a-popconfirm placement="top" @confirm="handleDelete(record.union_id)">
            <template slot="title">
              <p>确定要删除？</p>
              <span>删除后机器人相关功能将失效！</span>
            </template>
            <a>删除账户</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="$refs.editModal.show(record)">更新授权</a>
        </span>
      </s-table>
    </a-card>
    <add-modal ref="addModal" @ok="$refs.table.refresh(true)"></add-modal>
    <add-jy-modal ref="addJYModal" @ok="$refs.table.refresh(true)"></add-jy-modal>
    <edit-modal ref="editModal" @ok="$refs.table.refresh()"></edit-modal>

    <!-- 	设置自定义推广位同步 -->
    <custom-promotion-space ref="cpSpace"></custom-promotion-space>

  </page-view>
</template>

<script>
import { STable } from '@/components'
import CompanyApi from '@/api/company'
import { PageView } from '@/layouts'
import AddModal from './AddModal'
import AddJyModal from './AddJyModal'
import EditModal from './EditModal'
import CustomPromotionSpace from './CustomPromotionSpace'

import { mapGetters, mapActions } from 'vuex'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
const statusMap = {
  1: {
    status: 'processing',
    text: '正常',
  },
  3: {
    status: 'error',
    text: '已过期',
  },
}

export default {
  name: 'CompanyJingdongList',
  components: {
    PageView,
    STable,
    AddModal,
    EditModal,
    AddJyModal,
    DemoVideoAlert,
    CustomPromotionSpace,
  },
  data() {
    return {
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: '80px',
          scopedSlots: { customRender: 'serial' },
        },
        {
          title: '京东联盟ID',
          width: '150px',
          dataIndex: 'union_id',
        },
        {
          title: '授权KEY',
          dataIndex: 'auth_key',
        },
        {
          title: '同步订单',
          dataIndex: 'is_sync',
          scopedSlots: { customRender: 'is_sync' },
        },
        {
          title: '备注信息',
          width: '150px',
          scopedSlots: { customRender: 'remarks_text' },
        },
        {
          title: '操作',
          width: '250px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return CompanyApi.getJingdongList(Object.assign(parameter, this.queryParam))
      },
    }
  },
  filters: {
    statusFilter(expire_time) {
      const curTimestamp = new Date().getTime()
      let type
      if (expire_time * 1000 > curTimestamp) {
        type = 1
      } else {
        type = 3
      }
      return statusMap[type].text
    },
    statusTypeFilter(expire_time) {
      const curTimestamp = new Date().getTime()
      let type
      if (expire_time * 1000 > curTimestamp) {
        type = 1
      } else {
        type = 3
      }
      return statusMap[type].status
    },
  },
  created() { },
  methods: {
    ...mapActions(['demoSetVideo']),
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    async handleSysChange(e, id) {
      CompanyApi.setSysJd({
        union_id: id,
        status: e ? 2 : 0,
      })
    },

    handleDelete(id) {
      let loading = this.$message.loading('正在删除')
      CompanyApi.deleteJingdong({ union_id: id })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    },

    // 设置自定义推广位同步
    positionSync(record) {
      // console.log('设置自定义推广位同步=', record)
      this.$refs.cpSpace.show(record)
    },

  },
}
</script>
<style lang="less" scoped></style>
